import { env } from './env';

const APP_DEFAULT_URL = env.TAVOLA_BASE_URL || 'https://app.clicksign.com';

export const APP_ROUTES = {
  home: process.client ? window.origin : APP_DEFAULT_URL,
  signin: `${APP_DEFAULT_URL}/signin`,
  signup: `${APP_DEFAULT_URL}/signup`,
  signerArea: `${APP_DEFAULT_URL}/signer/dashboard`,
};

const HELP_DEFAULT_URL = 'https://ajuda.clicksign.com';
const REQUIREMENT_TOKEN_URL = `${HELP_DEFAULT_URL}/article/548-assinando-documento-token`;

export const HELP_LINKS = {
  home: HELP_DEFAULT_URL,
  signingDocument: `${HELP_DEFAULT_URL}/article/122-como-assinar-um-documento`,
  tokenAttempts: `${HELP_DEFAULT_URL}/article/911-limite-de-tentativas-de-envio-de-token-via-whatsapp`,
  requirement: {
    email: REQUIREMENT_TOKEN_URL,
    sms: REQUIREMENT_TOKEN_URL,
    whatsapp: REQUIREMENT_TOKEN_URL,
    pix: `${HELP_DEFAULT_URL}/article/558-assinando-um-documento-com-pix`,
    selfie: `${HELP_DEFAULT_URL}/article/332-assinando-documento-via-selfie-com-documento`,
    liveness: `${HELP_DEFAULT_URL}/article/574-assinando-um-documento-com-selfie-dinamica`,
    officialDocument: `${HELP_DEFAULT_URL}/article/545-assinando-com-documento-oficial`,
    facialBiometrics: `${HELP_DEFAULT_URL}/article/754-assinando-um-documento-com-biometria-facial`,
    icpBrasil: `${HELP_DEFAULT_URL}/article/659-assinando-com-certificado-digital`,
    handwritten: `${HELP_DEFAULT_URL}/article/544-assinando-documento-com-assinatura-manuscrita`,
  },
};

const INTERNAL_DEFAULT_URL = 'https://clicksign.com';

export const INTERNAL_LINKS = {
  home: INTERNAL_DEFAULT_URL,
  privacyPolicy: `${INTERNAL_DEFAULT_URL}/politica-de-privacidade`,
  termsOfAgreement: `${INTERNAL_DEFAULT_URL}/termos`,
  'es-MX': {
    privacyPolicy: `${INTERNAL_DEFAULT_URL}/es/politica-de-privacidade`,
    termsOfAgreement: `${INTERNAL_DEFAULT_URL}/es/termos-de-uso`,
  },
  status: 'https://status.clicksign.com',
};

export const EXTERNAL_LINKS = {
  installWebPkiExtension: 'https://get.webpkiplugin.com/setup',
};
